// import all of the images for each team member
import aidanobrien from "../../../img/Aidan O'Brien.png";
import leoCochrane from "../../../img/Leo Cochrane.png";
import riderbishop from "../../../img/Rider Bishop.jpg";
import yvonneLin from "../../../img/Yvonne Lin.png";
import alexChoi from "../../../img/Alex Choi.png";
import xavierYu from "../../../img/Xavier Yu.png";
import simranBajaj from "../../../img/Simran Bajaj.png";
import kaamilThobani from "../../../img/Kaamil Thobani.png";
import williamSeward from "../../../img/William Seward.png";
import rodrigoAldrey from "../../../img/Rodrigo Aldrey.png";
import pattyKang from "../../../img/Patty Kang.png";
import anishSanghi from "../../../img/Anish Sanghi.png";
import vinithaVivek from "../../../img/Vinitha Vivek.png";
import riaNarayanan from "../../../img/Ria Narayanan.png";
import hopeMcClew from "../../../img/Hope Mcclew.png";
import alexYang from "../../../img/Alex Yang.png";
import willChristianto from "../../../img/Will Christianto.png";
import joshWang from "../../../img/Josh Wang.png";
import elvinCheng from "../../../img/Elvin Cheng.png";

export const TeamMember = [
    {
        key: "member1",
        headshot: aidanobrien,
        name: "Aidan O'Brien",
        position: "President",
        team: "Board",
        linkedin: "https://www.linkedin.com/in/aidanaobrien/",
        alt: ""
    },
    {
        key: "member2",
        headshot: leoCochrane,
        name: "Leo Cochrane",
        position: "Vice President",
        team: "Board",
        linkedin: "https://www.linkedin.com/",
        alt: ""
    },
    {
        key: "member3",
        headshot: riderbishop,
        name: "Rider Bishop",
        position: "Director of Technology",
        team: "Tech Team",
        linkedin: "https://www.linkedin.com/in/rider-bishop/",
        alt: ""
    },
    {
        key: "member4",
        headshot: yvonneLin,
        name: "Yvonne Lin",
        position: "Position title",
        team: "Finnovate",
        linkedin: "https://www.linkedin.com/in/pengsyuan-lin/",
        alt: ""
    },
    {
        key: "member5",
        headshot: alexChoi,
        name: "Alex Choi",
        position: "Position title",
        team: "Finnovate",
        linkedin: "https://www.linkedin.com/",
        alt: ""
    },
    {
        key: "member6",
        headshot: xavierYu,
        name: "Xavier Yu",
        position: "Position title",
        team: "Events",
        linkedin: "https://www.linkedin.com/in/xavier-yu/",
        alt: ""
    },
    {
        key: "member7",
        headshot: simranBajaj,
        name: "Simran Bajaj",
        position: "Position title",
        team: "Events",
        linkedin: "https://www.linkedin.com/in/simrankbajaj/",
        alt: ""
    },
    {
        key: "member8",
        headshot: kaamilThobani,
        name: "Kaamil Thobani",
        position: "Position title",
        team: "Tech Team",
        linkedin: "https://www.linkedin.com/in/kaamil-thobani-9a7237210/",
        alt: ""
    },
    {
        key: "member9",
        headshot: williamSeward,
        name: "William Seward",
        position: "Position title",
        team: "Tech Team",
        linkedin: "https://www.linkedin.com/in/william-seward-2a04aa262/",
        alt: ""
    },
    {
        key: "member10",
        headshot: rodrigoAldrey,
        name: "Rodrigo Aldrey",
        position: "Position title",
        team: "Tech Team",
        linkedin: "https://www.linkedin.com/in/rodrigo-aldrey-558808244/",
        alt: ""
    },
    {
        key: "member11",
        headshot: pattyKang,
        name: "Patty Kang",
        position: "Position title",
        team: "Marketing",
        linkedin: "https://www.linkedin.com/in/peiti-kang-653212250/",
        alt: ""
    },
    {
        key: "member12",
        headshot: anishSanghi,
        name: "Anish Sanghi",
        position: "Position title",
        team: "Operations",
        linkedin: "https://www.linkedin.com/in/anishsanghi/",
        alt: ""
    },
    {
        key: "member13",
        headshot: vinithaVivek,
        name: "Vinitha Vivek",
        position: "Position title",
        team: "Finances",
        linkedin: "https://www.linkedin.com/in/vinitha-vivek/",
        alt: ""
    },
    {
        key: "member14",
        headshot: riaNarayanan,
        name: "Ria Narayanan",
        position: "Position title",
        team: "Research",
        linkedin: "https://www.linkedin.com/in/rianarayanan/",
        alt: ""
    },
    {
        key: "member15",
        headshot: hopeMcClew,
        name: "Hope McClew",
        position: "Research Analyst",
        team: "Research",
        linkedin: "https://www.linkedin.com/in/hope-mcclew-1386a8240/",
        alt: ""
    },
    {
        key: "member16",
        headshot: alexYang,
        name: "Alex Yang",
        position: "Position title",
        team: "Outreach",
        linkedin: "https://www.linkedin.com/in/yangalex1/",
        alt: ""
    },
    {
        key: "member17",
        headshot: willChristianto,
        name: "Will Christianto",
        position: "Position title",
        team: "Outreach",
        linkedin: "https://www.linkedin.com",
        alt: ""
    },
    {
        key: "member18",
        headshot: joshWang,
        name: "Josh Wang",
        position: "Co-director",
        team: "Elevate",
        linkedin: "https://www.linkedin.com/in/joshwang-p/",
        alt: ""
    },
    {
        key: "member19",
        headshot: elvinCheng,
        name: "Elvin Cheng",
        position: "Co-director",
        team: "Elevate",
        linkedin: "https://www.linkedin.com/in/elvin-cheng/",
        alt: ""
    }
];